import Vue from 'vue'
import Axios from 'axios'

Axios.defaults.headers.post['Content-Type'] = 'application/json'
const axiosInstance = Axios.create({
    baseURL: process.env.NODE_ENV === 'production' ? 'https://biobigdata.nju.edu.cn' : '/',
    withCredentials: true,
})

// 通过拦截器处理csrf问题，这里的正则和匹配下标可能需要根据实际情况小改动,并统一加上 X-API-Key
axiosInstance.interceptors.request.use((config) => {
    config.headers['X-Requested-With'] = 'XMLHttpRequest'
    const regex = /.*csrftoken=([^;.]*).*$/
    config.headers['X-CSRFToken'] = document.cookie.match(regex) === null ? null : document.cookie.match(regex)[1]

    const apiKey = 'k9AjfS0LTB6rGd5ZkXyL2yXc1wip0P6H-WZ0cV9xq9M'
    config.headers['X-API-Key'] = apiKey
    // console.log('API Key added to request headers.', apiKey)

    return config
})

axiosInstance.interceptors.response.use(
    response => {
        return response
    },
    error => {
        return Promise.reject(error)
    }
)

Vue.prototype.axios = axiosInstance

export default axiosInstance